'use client';

import { ColorSchemeSelectorDropdown } from '@/components/ColorSchemeSelectorDropdown';
import LayoutIcon from '@/components/LayoutIcon';
import { AppContext, AuthContext } from '@inway/layout';
import Link from 'next/link';
import { useContext } from 'react';
import { useTranslation } from './i18n/client';

export interface LandingProps {}

export default function Landing({}: LandingProps) {
  const { i18n, theme } = useContext(AppContext);
  const { inProgress, userId } = useContext(AuthContext);
  const { t } = useTranslation(i18n?.lng);

  const logoUrl = theme.logo.src ?? '/logo.svg';

  return (
    <div className="container">
      <nav className="navbar navbar-dark">
        <Link href="/" className="navbar-brand">
          <img src={logoUrl} alt="Brand logo" width="90" height="90" />
        </Link>
        <div className="d-flex ms-auto">
          {inProgress ? (
            <Link
              href="#"
              className="btn btn-primary disabled"
              prefetch={false}
              onClick={(ev) => ev.preventDefault()}
            >
              <LayoutIcon icon="circleNotch" spin />
            </Link>
          ) : userId ? (
            <Link
              href="/dashboard"
              className="btn btn-primary"
              prefetch={false}
            >
              {t('Show dashboard')}
            </Link>
          ) : (
            <Link href="/login" className="btn btn-primary">
              {t('Sign In')}
            </Link>
          )}
          {theme.preferredColorScheme != undefined &&
            theme.setPreferredColorScheme != undefined && (
              <ColorSchemeSelectorDropdown
                className="ms-1"
                preferredColorScheme={theme.preferredColorScheme}
                setPreferredColorScheme={theme.setPreferredColorScheme}
              />
            )}
        </div>
      </nav>
    </div>
  );
}
